import React from 'react'
import ViewProduct from "../component/ViewProduct";

export default function ProductView() {
  return (
    <ViewProduct />
  )
}
